"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoteCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./style.css");
var _ = require("..");
const NoteCard = props => {
  const {
    cardTitle,
    cardText,
    overrideClass
  } = props;
  return /*#__PURE__*/_react.default.createElement(_.Card, {
    cardTitle: cardTitle,
    cardText: cardText,
    overrideClass: `note-card ${overrideClass}`,
    cardTextTag: "div"
  });
};
exports.NoteCard = NoteCard;
NoteCard.defaultProps = {
  /** Specifies the note heading. */
  cardTitle: "",
  /** Specifies the note content. */
  cardText: "",
  /** Specifies the note styling override class. */
  overrideClass: ""
};
NoteCard.propTypes = {
  /** Specifies the note heading. */
  cardTitle: _propTypes.default.string.isRequired,
  /** Specifies the note content. */
  cardText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  /** Specifies the note styling override class. */
  overrideClass: _propTypes.default.string
};